import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import Draggable from "react-draggable";
import { motion } from "framer-motion";

const ReferenceSheet = ({ onClose }) => {
  const [position, setPosition] = useState({ x: 600, y: 100 });
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const handleDrag = (e, data) => {
    const { x, y } = data;
    const outOfBoundsX = x < 0 || x > window.innerWidth - 200;
    const outOfBoundsY = y < 0 || y > window.innerHeight - 200;

    if (outOfBoundsX || outOfBoundsY) {
      setPosition({ x: 0, y: 0 });
    } else {
      setPosition({ x, y });
    }
  };

  // Mobile Modal View
  if (isMobile) {
    return (
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="relative transform overflow-hidden bg-white w-full max-w-lg rounded-lg shadow-xl transition-all">
            {/* Modal Header */}
            <div className="bg-black text-white px-4 py-3 flex items-center justify-between">
              <h6 className="text-lg font-medium">Reference Sheet</h6>
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={onClose}
                className="rounded-full p-1 hover:bg-gray-700 transition-colors"
              >
                <IoMdClose size="1.5rem" />
              </motion.button>
            </div>
            
            {/* Modal Body */}
            <div className="overflow-y-auto max-h-[80vh] p-4">
              <img 
                src="/dashboard/sat_math.png" 
                alt="Reference"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Desktop Draggable View
  return (
    <Draggable handle=".modal-header" position={position} onStop={handleDrag}>
      <div className="absolute w-[50%] h-full top-14 z-50 cursor-pointer">
        <div className="bg-white border-2 border-lightgray shadow-lg rounded-lg overflow-hidden">
          <div className="modal-header flex flex-row items-center bg-black text-white p-3">
            <h6 className="flex-grow font-medium">Reference Sheet</h6>
            <motion.button 
              whileTap={{ scale: 0.97 }}
              className="hover:bg-gray-700 rounded-full p-1 transition-colors"
            >
              <IoMdClose 
                size="1.3rem" 
                onClick={onClose} 
                className="cursor-pointer" 
              />
            </motion.button>
          </div>
          <div className="modal-body p-4">
            <img 
              src="/dashboard/sat_math.png" 
              alt="Reference"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </Draggable>
  );
};

export default ReferenceSheet;